// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__wZm2Z","checkedHandle":"Switch_checkedHandle__QL6lp","uncheckedHandle":"Switch_uncheckedHandle__PLWX7"};